// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__ckiFH","text":"ErrorMessage_text__cHp10"};